import styled, { CSSProp } from 'styled-components';

export const Container = styled.div<{ styles?: CSSProp }>`
  ${({ styles }) => styles && styles};
`;

export const StyledIcon = styled.div``;
